import { useState } from 'react'
import ImageViewerDialog from '../../../../../components/ImageViewerDialog'

const FileAnswer = ({ answer }: { answer: wowaudit.ApplicationAnswer }) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null)

  return (
    <>
      <div className='flex items-center gap-2 flex-wrap'>
        {answer.attachments.map((attachment, index) => (
          <figure
            key={attachment.id}
            className='h-40'
            onClick={() => setSelectedIndex(index)}
          >
            <img
              src={attachment.url}
              alt={attachment.originalFilename}
              className='object-cover w-full h-full rounded-md border-2 border-accent hover:border-primary transition-colors cursor-pointer'
            />
          </figure>
        ))}
      </div>

      {selectedIndex !== null && (
        <ImageViewerDialog
          items={answer.attachments.map((attachment) => ({
            url: attachment.url,
            alt: attachment.originalFilename,
            title: attachment.originalFilename,
          }))}
          initialIndex={selectedIndex}
          open={selectedIndex !== null}
          onOpenChange={(open) => !open && setSelectedIndex(null)}
        />
      )}
    </>
  )
}

export default FileAnswer
